import ReactFlow, { MiniMap, Controls, Background, MarkerType } from 'react-flow-renderer';
import { withNamespaces } from 'react-i18next';
import Accordion from 'react-bootstrap/Accordion';
import { RiNodeTree } from 'react-icons/ri';
import { Col, Row } from 'reactstrap';

const nodeStyles = {
    globalUltimate: { background: '#388e3c', color: '#fff', border: '2px solid #4caf50', borderRadius: 10 },  
    domesticUltimate: { background: '#388e3c', color: '#fff', border: '2px solid #4caf50', borderRadius: 10 }, 
    parent: { background: '#388e3c', color: '#fff', border: '2px solid #4caf50', borderRadius: 10 },           
    currentCompany: { background: '#1976d2', color: '#fff', border: '2px solid #1976d2', borderRadius: 10 },  
    branch: { background: '#9C27B0', color: '#fff' }           
};

const generateNodes = ({
    t,
    globalUltimate,
    domesticUltimate,
    parent,
    currentCompany
}) => {
    return [
    {
        id: 'globalUltimate',
        type: 'default',
        data: { label: `${t('Global Ultimate')}\n${globalUltimate.name || '--'}\nDUNS: ${globalUltimate.duns}` },
        position: { x: 250, y: 0 },
        style: nodeStyles.globalUltimate
    },
    {
        id: 'domesticUltimate',
        type: 'default',
        data: { label: `${t('Domestic Ultimate')}\n${domesticUltimate.name || '--'}\nDUNS: ${domesticUltimate.duns}` },
        position: { x: 350, y: 130 },
        style: nodeStyles.domesticUltimate
    },
    {
        id: 'parent',
        type: 'default',
        data: { label: `${t('Parent')}\n${parent.name || '--'}\nDUNS: ${parent.duns}` },
        position: { x: 250, y: 270 },
        style: nodeStyles.parent
    },
    {
        id: 'currentCompany',
        type: 'default',
        data: { label: `${t('This Company')}\n${currentCompany.name || '--'}\nDUNS: ${currentCompany.duns}` },
        position: { x: 350, y: 390 },
        style: nodeStyles.currentCompany
    },
    // ...linkage.branches.map((branch, index) => ({
    //     id: `branch-${index}`,
    //     type: 'default',
    //     data: { label: `Branch\n${branch.tradeName}\nDUNS: ${branch.duns}` },
    //     position: { x: 100 + index * 200, y: 400 },
        // style: nodeStyles.branch
    // })),
]
}

const generateEdges = () => {
    return [
        { 
            id: 'e1', 
            source: 'globalUltimate', 
            target: 'domesticUltimate', 
            animated: true, 
            arrowHeadType: 'arrowclosed',
            markerEnd: { type: MarkerType.Arrow, color: "#555" },
            style: {
                stroke: "#555",  // arrow color
                strokeWidth: 1.5,  // thickness (default is 1)
            }
        },
        { 
            id: 'e2', 
            source: 'domesticUltimate', 
            target: 'parent', 
            animated: true, 
            arrowHeadType: 'arrowclosed',
            markerEnd: { type: MarkerType.Arrow, color: "#555" },
            style: {
                stroke: "#555",  // arrow color
                strokeWidth: 1.5,  // thickness (default is 1)
            }
        },
        { 
            id: 'e3', 
            source: 'parent', 
            target: 'currentCompany', 
            animated: true, 
            arrowHeadType: 'arrowclosed',
            markerEnd: { type: MarkerType.Arrow, color: "#555" },
            style: {
                stroke: "#555",  // arrow color
                strokeWidth: 1.5,  // thickness (default is 1)
            }
        },
        // ...linkage.branches.map((_, index) => ({
        //     id: `e-branch-${index}`,
        //     source: 'currentCompany',
        //     target: `branch-${index}`,
        //     animated: true,
        //        markerEnd: { type: MarkerType.Arrow, color: "#555" },
        //        style: {
        //            stroke: "#555",  // arrow color
        //            strokeWidth: 1.5,  // thickness (default is 1)
        //        }
        // })),
    ]
}

const ShareholdersGraph = ({
    infoQuery,

    t,
    activeAccordion,
    setActiveAccordion,
}) => {
    if (infoQuery.isFetching) {
        return (
            <Row>
                <Col
                    sm="12" 
                    className="mt-4 mb-4"
                >
                    <div 
                        className="dt-field dt-skeleton" 
                        style={{ width: '100%', height: '100px' }}
                    />
                </Col>
            </Row>
        )
    }

    const {
        company_shareholders = [],
        company
    } = infoQuery.data;

    const domesticUltimate = company_shareholders.find((sh) => sh.companyType === 'domestic')
    const globalUltimate = company_shareholders.find((sh) => sh.companyType === 'global')
    const parent = company_shareholders.find((sh) => sh.companyType === 'headquarters')
    const currentCompany = {
        duns: company.duns,
        name: company.tradeName || company.primaryName
    };

    return (
        <Accordion.Item
            onClick={() => setActiveAccordion('shareholders-graph')}
            className={activeAccordion === 'shareholders-graph' ? 'active' : ''}
            eventKey={'shareholders-graph'}
        >
            <Accordion.Header>
                <RiNodeTree size="24" className="me-2" />
                <span>
                    {t('Shareholders Graph')}
                </span>
            </Accordion.Header>

            <Accordion.Body>
                <div style={{ height: 500, width: '100%' }}>
                    <ReactFlow
                        nodes={generateNodes({
                            domesticUltimate,
                            globalUltimate,
                            parent,
                            currentCompany,
                            t
                        })}
                        edges={generateEdges()}
                        nodesConnectable={false}
                        nodesDraggable
                        elementsSelectable
                    >
                        <MiniMap
                            nodeStrokeColor={(n) => (n.style?.backgroundColor ? n.style.backgroundColor : "#eee")}
                            nodeColor={(node) => node.style.background}
                        />
                        <Controls />
                        <Background color="#aaa" gap={16} />
                    </ReactFlow>
                </div>
            </Accordion.Body>
        </Accordion.Item>
    );
}

export default withNamespaces()(
    ShareholdersGraph
);